import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

/**
 * Cliente de las métricas de mascotas protegidas y potencial (spec 030 / backend 096).
 *
 * El endpoint responde con el envelope `{ data }`: el éxito se determina por el
 * código HTTP. Todo el cálculo vive en el backend; el front solo formatea.
 */
export default class PetProtectionMetricsService {
  static getHeaders() {
    const accessToken = JSON.parse(localStorage.getItem('accessToken'));
    return { Authorization: `Bearer ${accessToken}` };
  }

  /**
   * @param {{ from?: string }} params - Primer mes de la serie (YYYY-MM); sin él, 24 meses.
   * @returns {Promise<{status: string, data?: object}>}
   */
  static async getMetrics({ from } = {}) {
    try {
      const params = new URLSearchParams();
      if (from) params.append('from', from);
      const query = params.toString();
      const response = await axios.get(
        `${adminUrl}/pet-protection-metrics${query ? `?${query}` : ''}`,
        { headers: this.getHeaders() }
      );
      return { status: 'ok', data: response.data.data };
    } catch (error) {
      return { status: 'error' };
    }
  }
}
